var TopBar = function() {
	this.mystartBarInner = document.getElementById( "sw-mystart-inner" );
	this.siteID = document.getElementById( "sps-site-id" ).value;
};

TopBar.prototype = {
	Fill : function() {
		this.StaffButton();
		this.DistrictHome();
	},

	StaffButton : function() {
		if( this.siteID !== "-1" && this.mystartBarInner ) {
			var myStartSPS = document.createElement("div");
			myStartSPS.id = "sw-mystart-sps";

			var staffPortalCon = document.createElement("div");
			staffPortalCon.classList.add("sw-mystart-nav", "sw-mystart-button");
			staffPortalCon.id = "sps-staff-portal";

			var staffPortalLink = document.createElement("a");
			staffPortalLink.href = "/staff";
			staffPortalLink.innerText = "Staff";

			staffPortalCon.insertAdjacentElement("beforeend", staffPortalLink);
			myStartSPS.insertAdjacentElement("beforeend", staffPortalCon);

			this.mystartBarInner.insertAdjacentElement("beforeend", myStartSPS);
			
			var mystartBarRight = document.getElementById( "sw-mystart-right" );

			if (mystartBarRight ) {
				var isDistrictTemplate = ( this.siteID === "8" || this.siteID === "83" );

				mystartBarRight.parentNode.removeChild( mystartBarRight );
				document.querySelector(
					(isDistrictTemplate ? ".sps-footer-bottom" : "#sps-footer-translate" ) ).insertAdjacentElement(
						(isDistrictTemplate ? "beforeend" : "afterend" ),
					mystartBarRight
				);
			}
		}	
	},

	DistrictHome : function() {
		if ( this.siteID !== "8") {
			this.mystartBarInner.classList.add( "sps-districthome" );
			document.querySelector( ".sw-mystart-button.home" ).style.display = "block";
		}
	}
};
